// extracted by mini-css-extract-plugin
export default {"title":"iaa-z","warning":"jaa-z","sizeOptionsLegendText":"kaa-z"};